import { render } from "./ViewInstitute.vue?vue&type=template&id=209016c2&scoped=true"
import script from "./ViewInstitute.vue?vue&type=script&lang=js"
export * from "./ViewInstitute.vue?vue&type=script&lang=js"

import "./ViewInstitute.vue?vue&type=style&index=0&id=209016c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209016c2"]])

export default __exports__